<!--
  Angular 15: *ngIf / *ngFor only, no @if blocks.
-->
<div class="legal-dialog-backdrop" *ngIf="isOpen">
  <form
    class="legal-dialog"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="heading"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="isOpen"
    (ngSubmit)="save()"
    data-testid="legal-form">

    <h2 class="legal-dialog__title">{{ heading }}</h2>

    <div class="legal-dialog__meta">
      <div class="dl-field">
        <label class="dl-field__label" for="legalTitle">Title *</label>
        <input id="legalTitle" name="title" class="dl-input" [(ngModel)]="title"
               maxlength="255" autocomplete="off" [disabled]="saving" data-testid="legal-form-title" />
      </div>

      <div class="dl-field">
        <label class="dl-field__label" for="legalSummary">What changed</label>
        <textarea id="legalSummary" name="changeSummary" class="dl-input legal-dialog__summary"
                  [(ngModel)]="changeSummary" maxlength="2000" [disabled]="saving"
                  placeholder="Shown to users above the text, e.g. “Dodat odeljak o čuvanju podataka.”"
                  data-testid="legal-form-summary"></textarea>
      </div>
    </div>

    <div class="legal-dialog__editor">
      <div class="dl-field legal-dialog__pane">
        <label class="dl-field__label" for="legalContent">Text (Markdown) *</label>
        <textarea id="legalContent" name="content" class="dl-input legal-dialog__source"
                  [(ngModel)]="content" [disabled]="saving" spellcheck="true"
                  placeholder="# Naslov&#10;&#10;## 1. Uvod&#10;&#10;Tekst…"
                  data-testid="legal-form-content"></textarea>
        <span class="dl-field__hint"># heading · **bold** · *italic* · - list · 1. numbered list · [link](https://…)</span>
      </div>

      <div class="legal-dialog__pane">
        <span class="dl-field__label">Preview</span>
        <div class="legal-dialog__preview legal-markdown" [innerHTML]="content | markdown"
             data-testid="legal-form-preview"></div>
      </div>
    </div>

    <div class="dl-banner dl-banner--error legal-dialog__error" *ngIf="error">
      <mat-icon>error</mat-icon>
      <div class="dl-banner__body">{{ error }}</div>
    </div>

    <div class="legal-dialog__actions">
      <span class="dl-field__hint legal-dialog__note">Saving keeps it a draft. Users see nothing until you publish.</span>
      <button type="button" class="dl-btn" [disabled]="saving" (click)="close()">Cancel</button>
      <button type="submit" class="dl-btn dl-btn--primary" [disabled]="!canSave" data-testid="legal-form-save">
        {{ saving ? 'Saving…' : 'Save draft' }}
      </button>
    </div>
  </form>
</div>
